import * as React from "react";
import { Form, Formik, useFormikContext } from "formik";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Icon, MultiSelect } from "components/common";
import { Button } from "components/bootstrap";
import TimeRangeFilter from "views/components/searchbar/time-range-filter";
import TimeRangeInputSettingsContext from "views/components/contexts/TimeRangeInputSettingsContext";
import { isTimeRange } from "views/typeGuards/timeRange";
import useWorkflowTypeOptions from "./hooks/useWorkflowTypeOptions";
const timeRangeInputSettings = {
  showDropdownButton: false,
  showPresetsButton: true,
  showAddToQuickListButton: false
};
const WORKFLOW_TYPE_PLACEHOLDER_KEY = "usage_search_form.workflow_type_placeholder";
const CONTROL_HEIGHT = "34px";
const FiltersGrid = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.spacings.sm};
    align-items: start;

    @media (max-width: ${theme.breakpoints.max.sm}) {
      grid-template-columns: 1fr;
    }
  `
);
const ApplyButton = styled(Button)`
  height: ${CONTROL_HEIGHT};
  width: 64px;
`;
const StyledTimeRangeFilter = styled(TimeRangeFilter)`
  min-width: 0;
  height: ${CONTROL_HEIGHT};
`;
const LeftSideContainer = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: ${theme.spacings.sm};
    align-items: start;
  `
);
const filterValues = (value) => {
  const values = value.split(",").filter(Boolean);
  return values.length > 0 ? values : null;
};
const selectValue = (value) => {
  var _a;
  return (_a = value == null ? void 0 : value.join(",")) != null ? _a : "";
};
const UsageSearchFormContent = () => {
  const { t } = useTranslation("enterprise_ai");
  const { setFieldValue, values } = useFormikContext();
  const { data: workflowTypes, isLoading: workflowTypesLoading } = useWorkflowTypeOptions();
  return /* @__PURE__ */ React.createElement(FiltersGrid, null, /* @__PURE__ */ React.createElement(LeftSideContainer, null, /* @__PURE__ */ React.createElement(
    ApplyButton,
    {
      type: "submit",
      bsStyle: "primary",
      title: t("usage_search_form.apply_filters"),
      "aria-label": t("usage_search_form.apply_filters")
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "search", size: "lg" })
  ), /* @__PURE__ */ React.createElement(TimeRangeInputSettingsContext.Provider, { value: timeRangeInputSettings }, /* @__PURE__ */ React.createElement(
    StyledTimeRangeFilter,
    {
      value: values.timerange,
      onChange: (nextTimeRange) => {
        if (isTimeRange(nextTimeRange)) {
          setFieldValue("timerange", nextTimeRange);
        }
      },
      limitDuration: 0,
      position: "bottom-start",
      submitOnPresetChange: false
    }
  ))), /* @__PURE__ */ React.createElement(
    MultiSelect,
    {
      "aria-label": t(WORKFLOW_TYPE_PLACEHOLDER_KEY),
      id: "usage-workflow-type",
      inputId: "usage-workflow-type",
      name: "type",
      options: workflowTypes,
      placeholder: t(WORKFLOW_TYPE_PLACEHOLDER_KEY),
      value: selectValue(values.type),
      onChange: (type) => setFieldValue("type", filterValues(type)),
      isLoading: workflowTypesLoading
    }
  ));
};
const UsageSearchForm = ({ filters, onApply }) => /* @__PURE__ */ React.createElement(
  Formik,
  {
    initialValues: filters,
    enableReinitialize: true,
    onSubmit: (values) => onApply({ ...values, provider: null, model: null })
  },
  /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(UsageSearchFormContent, null))
);
export default UsageSearchForm;
